import React, { useEffect, useState } from "react";
import { get, patch } from "../lib/api";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
export default function CustomerNotifications({ compact = false }) {
  const [items, setItems] = useState([]),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(true);
  useEffect(() => {
    get("/notifications")
      .then((r) => setItems(r.notifications))
      .catch(() => setError("Unable to load notifications."))
      .finally(() => setLoading(false));
  }, []);
  const read = async (item) => {
    try {
      await patch("/notifications/" + item._id + "/read", {});
      setItems((current) =>
        current.map((n) => (n._id === item._id ? { ...n, isRead: true } : n)),
      );
    } catch {
      setError("Unable to mark notification as read.");
    }
  };
  return (
    <section className={compact ? "divide-y divide-gray-200 overflow-hidden rounded-lg border bg-white" : "space-y-3"}>
      {!compact && <h2 className="text-xl font-semibold">Notifications</h2>}
      {error && (
        <p role="alert" className="text-red-700">
          {error}
        </p>
      )}
      {loading && <p>Loading notifications...</p>}
      {!loading && !items.length && (
        <p className="text-slate-500">No notifications yet.</p>
      )}
      {items.map((item) => (
        <article
          key={item._id}
          className={
            (compact ? "p-3 " : "rounded-xl border p-4 ") + (item.isRead ? "bg-white" : "bg-blue-50")
          }
        >
          <p className="whitespace-pre-wrap text-sm">{item.message}</p>
          <div className="mt-3 flex items-center justify-between gap-2">
            <time className="text-xs text-slate-500">
              {new Date(item.createdAt).toLocaleString()}
            </time>
            {item.action === "VENDOR_SETUP" && (
              <Link
                className="inline-block text-sm font-semibold text-primary underline"
                to="/vendor-setup"
              >
                Complete vendor setup
              </Link>
            )}
            {!item.isRead && (
              <Button size="sm" variant="outline" onClick={() => read(item)}>
                Mark as read
              </Button>
            )}
          </div>
        </article>
      ))}
    </section>
  );
}
